import "$styles/index.css"
import '@justinribeiro/lite-youtube';

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
